module.exports = __webpack_public_path__ + "img/modelo3.e5a28bb5.jpg";